import { render, staticRenderFns } from "./TranslationJob.vue?vue&type=template&id=80611bd8&scoped=true"
import script from "./TranslationJob.vue?vue&type=script&lang=ts"
export * from "./TranslationJob.vue?vue&type=script&lang=ts"
import style0 from "./TranslationJob.vue?vue&type=style&index=0&id=80611bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80611bd8",
  null
  
)

export default component.exports